import ModalFactory from '../factory';

import Content from './LogsModal';

const LogsModal = ModalFactory(Content);

export default LogsModal;
